export default __webpack_public_path__ + "static/media/RedHeart.b74f16b3.svg";